import { Box, Typography } from '@mui/material'

export const FormBox = ({ title, children }) => {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'gray-line.main',
        bgcolor: 'white.main',
        borderRadius: '4.5px',
      }}
    >
      <Box sx={{ p: 3, borderBottom: 1, borderColor: 'gray-line.main' }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          {title}
        </Typography>
      </Box>
      <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>{children}</Box>
    </Box>
  )
}
